document.addEventListener("DOMContentLoaded", function() {

    const fixSnizeListProducts = () => {
        const resultItems = document.querySelectorAll(`.snize-product.snize-product-in-stock , .snize-product-pre-order`);
        if (resultItems.length) {
            resultItems.forEach((resultItem) => {
                const productId = resultItem.getAttribute("data-original-product-id");
                if (productId) {
                   
                        const searchProductPrice = resultItem.querySelector(".snize-price-list");
                        searchProductPrice.setAttribute("bss-b2b-product-id", productId);
                        searchProductPrice.setAttribute("bss-b2b-product-price", "");
                    
                }
            });
        }
    }
    fixSnizeListProducts()

     const bss = setInterval(()=>{
        let a = document.querySelectorAll(`.snize-product.snize-product-in-stock`);
        if (a.length) {
               fixSnizeListProducts()
             clearInterval(bss)
        }
  
       },200)


        const bss1 = setInterval(()=>{
        let b = document.querySelectorAll('.bcpo-front-button-label');
        if (b.length) {
            b.forEach(element => {
                element.addEventListener('click', (e)=>{
                 
                     const forValue = e.target.getAttribute('for');
                    const cleanValue = forValue.replace(/^val/, '');
                    let price =  document.querySelector('[bss-b2b-main-product-form] [bss-b2b-featured-product]')
                    price.setAttribute('bss-b2b-variant-id', cleanValue)
                    const productForm = document.querySelector("[bss-b2b-main-product-form]");
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                })
            });
             clearInterval(bss1)
        }
  
       },200)
  setTimeout(()=>{
     clearInterval(bss1)
  },5000)

});